export { default as LabelSolidIcon } from './LabelSolidIcon';
